import React from "react";
import PropTypes from "prop-types";
import AsyncAutoComplete from "components/AsyncAutoComplete";
import loadHYFundTypesService from "services/hy/loadHYFundTypesService";

function SelectHYFundType({
  onSelect,
  disabled,
  error,
  placeholder,
  value,
  readOnly,
}) {
  return (
    <AsyncAutoComplete
      promiseFn={loadHYFundTypesService}
      onSelect={onSelect}
      textPath="name"
      labelPath="name"
      idPath="id"
      disabled={disabled}
      error={error}
      intent={!!error ? "danger" : null}
      placeholder={placeholder}
      value={value}
      readOnly={readOnly}
    />
  );
}

SelectHYFundType.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  initialValue: PropTypes.object,
  placeholder: PropTypes.string,
};

SelectHYFundType.defaultProps = {
  value: undefined,
  disabled: false,
  error: null,
  initialValue: {},
  placeholder: "Search...",
};

export default SelectHYFundType;
